<template>
  <el-dialog title="绑定营销业务员/网点" :visible.sync="dialogVisible" :before-close="closeDialog" width="600px" :close-on-click-modal="false">
    <div v-if="(bindUserInfo.bindOrgCode || bindUserInfo.bindEmployeeCode) && !isChangeBind" class="y-mb-30">
      <!-- 显示已绑定的网点或业务员信息 -->
      <div class="y-mt-30">
        <el-alert class="alert error-tip success-tip" title="" type="success" show-icon :closable="false">
          <div>已绑定{{bindUserInfo.bindEmployeeCode ? '营销业务员' : '网点'}}，当前逆向退货<span class="y-fc-1ACB42">每单</span>将<span class="y-fc-1ACB42">减免0.1元</span>。</div>
        </el-alert>
      </div>
      <div class="content-userinfo y-mt-25 y-f y-f-jc">
        <div class="y-f y-f-a y-f-jb box">
          <template v-if="bindUserInfo.bindOrgCode">
            <div>网点编码：{{bindUserInfo.bindOrgCode}}</div>
            <div>网点名称：{{bindUserInfo.orgName}}</div>
          </template>
          <template v-else>
            <div>业务员工号：{{bindUserInfo.bindEmployeeCode}}</div>
            <div>业务员姓名：{{bindUserInfo.employeeName}}</div>
          </template>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- 绑定界面 -->
      <div class="" style="text-align:left;padding: 0;">
        <el-alert class="alert error-tip" title="" type="warning" show-icon :closable="false">
          <div>绑定营销业务员或网点后，逆向退货<span class="y-fc-FF4D4F">每单</span>将<span class="y-fc-FF4D4F">减免0.1元</span>。</div>
        </el-alert>
      </div>
      <div class="content y-mt-30">
        <el-form :model="form" label-width="10px" ref="ruleForm" class="y-p-r" label-position="inline" >
          <div class="y-f y-f-a y-f-jc">
            <el-form-item label="" prop="searchType">
              <el-select v-model="form.searchType" class="y-w-160">
                <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=""  prop="bindCode">
              <el-input placeholder="请输入..." v-model.trim="form.bindCode" clearable class="y-w-250"></el-input>
            </el-form-item>
            <el-form-item label="" prop="">
              <span class="y-fc-systemcolor y-c-p y-ml-10" @click="searchOrgEmployeeInfo">搜索</span>
            </el-form-item>
          </div>
          <div class="searchResult y-mt-30 y-ml-50">
            <el-form-item label="" prop="">
              <div v-if="searchUserInfo.bindCode">
                <div>{{searchUserInfo.bindType == 'ORG' ? '网点编码' : '业务员工号'}}：{{searchUserInfo.bindCode}}</div>
                <div class="y-mt-10">{{searchUserInfo.bindType == 'ORG' ? '网点名称' : '业务员姓名'}}：{{searchUserInfo.name}}</div>
              </div>
            </el-form-item>          
          </div>
        </el-form>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button @click="closeDialog" >取 消</el-button>
      <template v-if="(bindUserInfo.bindOrgCode || bindUserInfo.bindEmployeeCode) && !isChangeBind">
        <el-button @click="unBindUserFn">解绑</el-button>
        <el-button type="primary" @click="changeBindUserFn">换绑</el-button>
      </template>
      <el-button type="primary" @click="bindUserFn" v-else>确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { bindUserApi, unBindUserApi, searchOrgEmployeeInfoApi } from '@/api/waybillPrint/returnPickupPrint'
export default {
  name: "acitivity-dialog",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    bindUser: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: this.isShow,
      form: {
        bindCode: '',
        searchType: 'ORG',
      },
      options: [
        {name: '网点编码', value: 'ORG'},
        {name: '业务员工号', value: 'EMPLOYEE'}
      ],
      searchUserInfo: {},
      bindUserInfo: {},
      isChangeBind: false, // 是否换绑
    };
  },
  watch: {
    bindUser: {
      handler(val) {
        this.bindUserInfo = val;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    closeDialog(refresh) {
      this.dialogVisible = false;
      this.$emit('closeDialog', refresh);
    },
    bindUserFn(flag) {
      if (!this.searchUserInfo.bindCode) {
        this.$message.error('请先查询网点或业务员信息');
        return false;
      }
      let params = {
        bindType: this.searchUserInfo.bindType,
        bindCode: this.searchUserInfo.bindCode,
        bindCheckPass: flag == 'changeBind' || this.isChangeBind, // 是否换绑， true 是， false 否
      }
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      bindUserApi(params).then(res => {
        loadingMask.close();
        if (res.message == 'ok') {
          this.$message.success('绑定成功');
          this.closeDialog('refresh');
        } else if (res.error && res.error.indexOf('是否换绑') > -1){
          this.$alert(res.error, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              if (action === 'confirm') {
                // 点击了确定
                this.bindUserFn('changeBind');
              }
            }
          });
        } else {
          this.$message.error(res.error || '绑定失败');
        }
      }).catch((err)=>{
        this.$message.error(err.error || '绑定失败');
        loadingMask.close();
      });
    },
    unBindUserFn() {
      this.$confirm('解除绑定后，后续订单将失去每单0.1元运费减免，请确认?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          bindType: this.bindUserInfo.bindOrgCode ? 'ORG' : 'EMPLOYEE',
          bindCode: this.bindUserInfo.bindOrgCode || this.bindUserInfo.bindEmployeeCode
        };
        let loadingMask = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        });
        unBindUserApi(params).then(res => {
          loadingMask.close();
          if (res.message == 'ok') {
            this.$message.success('解除绑定成功');
            this.closeDialog('refresh');
          } else {
            this.$message.error(res.error || '解除绑定失败');
          }
        }).catch(err => {
          this.$message.error(err.error || '解除绑定失败');
          loadingMask.close();
        });
      });
    },
    changeBindUserFn() {
      this.isChangeBind = true;
    },
    searchOrgEmployeeInfo() {
      if (!this.form.bindCode) {
        this.$message.error('请输入网点编码或业务员工号');
        return false;
      }
      let params = {
        bindType: this.form.searchType,
        bindCode: this.form.bindCode
      }
      this.searchUserInfo = {};
      searchOrgEmployeeInfoApi(params).then(res => {
        if (res.message == 'ok') {
          this.searchUserInfo = res.data;
          this.searchUserInfo.bindType = params.bindType;
        } else {
          this.$message.error(res.error || '查询失败');
        }
      });
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 0;
  .content {
    padding: 10px 20px;
  }
  .dialog-footer {
    border-top: 1px solid #EDEDED;
    text-align: right;
    padding: 20px 24px;
  }
}
/deep/ .el-dialog__footer {
  text-align: center;
}
/deep/ .el-alert--warning.is-light.error-tip {
  background: #ffeded;
  border: 0;
  color: #222;
  font-size: 14px;
  line-height: 20px;
  justify-content: center;
  padding: 8px 10px;
  .el-alert__icon.el-icon-warning {
    align-self: baseline;
    font-size: 16px;
    color: #FF4D4F;
    margin-top: 2px;
  }
  .el-alert__description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }
}
/deep/ .el-alert--success.is-light.success-tip{
  background: #fff;
  border: 0;
  color: #222;
  font-size: 16px;
  line-height: 20px;
  justify-content: center;
  padding: 8px 10px;
  .el-alert__icon.el-icon-success {
    align-self: baseline;
    font-size: 18px;
    color: #1ACB42;
    margin-top: 1px;
  }
  .el-alert__description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }
}
.y-fc-FF4D4F {
  color: #FF4D4F;
}
.y-fc-1ACB42 {
  color: #1ACB42;
}
.content-userinfo {
  .box {
    width: 420px;
    background: #F2F3F4;
    border-radius: 4px;
    padding: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #52585F;
    line-height: 20px;
  }
}
</style>